// extracted by mini-css-extract-plugin
export var growableInput = "_7o-0";
export var tagContainer = "_7o-2";
export var textInput = "_7o-1";